module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"title":"Insira seus dados","password":{"label":"Informe sua senha:","type":{"text":"Mostrar","password":"Esconder"},"reset":"Resetar senha"},"busy":"Entrando","action":"Entrar","rd":"Entrar com RD Station","call":"Ainda não possuo cadastro.","register":"Cadastre-se agora."}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Auth/Login.vue
// module id = 122
// module chunks = 0